function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z",
  fill: "#e9e9e0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d9d7ca",
  d: "M37.5.151V12h11.849z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
  fill: "#71c285"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.453 53h-1.668V42.924h1.668V53zM28.67 50.238c0 .364-.075.718-.226 1.06s-.362.643-.636.902-.611.467-1.012.622a3.771 3.771 0 01-1.367.232c-.219 0-.444-.012-.677-.034s-.468-.062-.704-.116c-.237-.055-.463-.13-.677-.226s-.399-.212-.554-.349l.287-1.176c.127.073.289.144.485.212s.398.132.608.191c.209.06.419.107.629.144.209.036.405.055.588.055.556 0 .982-.13 1.278-.39s.444-.645.444-1.155c0-.31-.105-.574-.314-.793-.21-.219-.472-.417-.786-.595s-.654-.355-1.019-.533a6.173 6.173 0 01-1.025-.629 3.264 3.264 0 01-.793-.854c-.21-.328-.314-.738-.314-1.23 0-.446.082-.843.246-1.189s.385-.641.663-.882.602-.426.971-.554.759-.191 1.169-.191c.419 0 .843.039 1.271.116.428.077.774.203 1.039.376a13.31 13.31 0 01-.191.39l-.205.396c-.064.123-.119.226-.164.308a1.263 1.263 0 01-.082.137c-.055-.027-.116-.063-.185-.109s-.167-.091-.294-.137a2.107 2.107 0 00-.506-.096 4.781 4.781 0 00-.807.014c-.183.019-.355.07-.52.157s-.311.193-.438.321a1.446 1.446 0 00-.301.431 1.1 1.1 0 00-.109.458c0 .364.104.658.314.882.209.224.469.419.779.588.31.169.646.333 1.012.492.364.159.704.354 1.019.581s.576.513.786.854c.212.342.318.781.318 1.319zM38.568 47.914c0 .848-.107 1.595-.321 2.242s-.511 1.185-.889 1.613-.82.752-1.326.971-1.06.328-1.661.328-1.155-.109-1.661-.328-.948-.542-1.326-.971-.675-.966-.889-1.613-.321-1.395-.321-2.242.107-1.593.321-2.235.511-1.178.889-1.606.82-.754 1.326-.978 1.06-.335 1.661-.335 1.155.111 1.661.335.948.549 1.326.978.675.964.889 1.606.321 1.387.321 2.235zm-4.238 3.815c.337 0 .658-.066.964-.198s.579-.349.82-.649.431-.695.567-1.183.209-1.082.219-1.784c-.01-.684-.08-1.265-.212-1.743s-.314-.873-.547-1.183-.497-.533-.793-.67-.608-.205-.937-.205c-.338 0-.658.063-.964.191s-.579.344-.82.649-.431.699-.567 1.183-.21 1.075-.219 1.777c.009.684.08 1.267.212 1.75s.314.877.547 1.183.497.528.793.67.609.212.937.212z"
}));

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 21,
  r: 12,
  fill: "#c8bdb8"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 21,
  r: 3,
  fill: "#e9e9e0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M25.379 18.879c.132-.132.276-.245.425-.347l-2.361-8.813a11.925 11.925 0 00-4.427 2.796 11.912 11.912 0 00-2.796 4.427l8.813 2.361a2.93 2.93 0 01.346-.424zM30.071 23.486l2.273 8.483a11.923 11.923 0 003.641-2.484 11.937 11.937 0 002.743-4.275l-8.188-2.194a.383.383 0 00-.469.47z",
  fill: "#d3ccc9"
});

var SvgIso = function SvgIso(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default SvgIso;